const isDev = process.env.NODE_ENV === 'development';
const apiBase = process.env.VUE_APP_API_BASE_URL || '/';

export default {
  // Vue Router 中使用的登录页/首页路由名
  LOGIN_PAGE: 'login',
  HOME_PAGE: 'home',

  // 鉴权路由缓存 key
  AUTH_ROUTE_KEY: 'authRoute',

  // 后端 API 前缀（建议在 .env.* 中配置完整域名，如 http://satest.com/）
  API_PATH: apiBase.endsWith('/') ? apiBase : apiBase + '/',

  // 是否展示演示路由
  SHOW_DEMO: false,

  // 是否使用单页布局（关闭 tags-nav）
  IS_SINGLE_PAGE: false,

  // 侧边栏默认图标
  DEFAULT_MENU_ICON: 'md-menu',

  // 预留环境标记
  ENV: isDev ? 'development' : 'production',
};
